var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.7001C16.4 17.7001 16.3 17.7001 16.2 17.6001L7.20002 12.4001C7.10002 12.4001 6.90002 12.2001 6.90002 12.0001C6.90002 11.8001 7.00002 11.6001 7.20002 11.5001L16.2 6.3001C16.5 6.1001 16.8 6.2001 17 6.5001C17.2 6.8001 17.1 7.1001 16.8 7.3001L8.70002 12.0001L16.8 16.7001C17.1 16.9001 17.2 17.2001 17 17.5001C16.9 17.6001 16.7 17.7001 16.5 17.7001Z",
    fill: "#006FAD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.8 13.2L8.70002 12L10.8 10.8C10.7 10.4 10.5 10.1 10.2 9.80005L7.20002 11.5C7.10002 11.6 6.90002 11.8 6.90002 12C6.90002 12.2 7.00002 12.4 7.20002 12.5L10.2 14.2C10.4 13.9 10.6 13.6 10.8 13.2Z",
    fill: "url(#paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 14.8C8.3464 14.8 9.6 13.5463 9.6 12C9.6 10.4536 8.3464 9.19995 6.8 9.19995C5.2536 9.19995 4 10.4536 4 12C4 13.5463 5.2536 14.8 6.8 14.8Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M5.7 9.3999C4.7 9.7999 4 10.7999 4 11.9999C4 13.5999 5.3 14.7999 6.8 14.7999C7.6 14.7999 8.4 14.3999 8.9 13.7999C4.5 14.3999 4.2 10.9999 5.7 9.3999Z",
    fill: "#223962"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 9.6C18.7464 9.6 20 8.3464 20 6.8C20 5.2536 18.7464 4 17.2 4C15.6536 4 14.4 5.2536 14.4 6.8C14.4 8.3464 15.6536 9.6 17.2 9.6Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.1 4.19995C15.1 4.59995 14.4 5.59995 14.4 6.79995C14.4 8.39995 15.7 9.59995 17.2 9.59995C18 9.59995 18.8 9.19995 19.3 8.59995C14.8 9.19995 14.6 5.79995 16.1 4.19995Z",
    fill: "#744D16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 19.9999C18.7464 19.9999 20 18.7463 20 17.1999C20 15.6535 18.7464 14.3999 17.2 14.3999C15.6536 14.3999 14.4 15.6535 14.4 17.1999C14.4 18.7463 15.6536 19.9999 17.2 19.9999Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.1 14.5999C15.1 14.9999 14.4 15.9999 14.4 17.1999C14.4 18.7999 15.7 19.9999 17.2 19.9999C18 19.9999 18.8 19.5999 19.3 18.9999C14.8 19.5999 14.6 16.0999 16.1 14.5999Z",
    fill: "#671C23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.0491,
    y1: 11.4012,
    x2: 11.2189,
    y2: 11.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.9824,
    y1: 7.07155,
    x2: 8.2925,
    y2: 12.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.2434,
    y1: 4.4389,
    x2: 17.6087,
    y2: 7.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 13.0662,
    y1: 14.3616,
    x2: 19.6149,
    y2: 18.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Share.13a0a838.svg";
export { ForwardRef as ReactComponent };